var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDottedShape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 82,
    viewBox: "0 0 71 82",
    width: 71,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff57"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -79.41323 81.99997)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -68.032 93.3812)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -56.6493 104.7639)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -45.2689 116.1443)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -33.8869 127.5263)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.8994 149.5138)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9441,
    cy: 80.7066,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -22.7625 138.6507)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 69.3248,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -68.03143 70.61817)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 69.3248,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -56.6502 81.9994)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 69.3248,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -45.2675 93.3821)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 69.3248,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -33.8871 104.7625)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 69.3253,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -22.5056 116.145)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 69.3253,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -.5181 138.1325)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9434,
    cy: 69.3253,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.3819 127.2687)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 57.9434,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -56.65003 59.23677)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -22.76333 25.35007)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 57.9434,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -45.2688 70.618)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.3821 36.7313)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 57.9434,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -33.8861 82.0007)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 .0006 48.114)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 57.9434,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -22.5057 93.3811)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 11.381 59.4944)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 57.943,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.1233 104.7627)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 22.763 70.8764)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 57.943,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 10.8642 126.7502)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 44.7505 92.8639)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9434,
    cy: 57.943,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 .0004 115.8864)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9441,
    cy: 24.0567,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 33.8874 82.0008)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -45.26823 47.85497)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.38173 13.96847)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -33.887 59.2362)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -.0005 25.3497)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -22.5043 70.6189)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 11.3822 36.7324)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.1239 81.9993)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 22.7626 48.1128)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 .2581 93.3813)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 34.1446 59.4948)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 22.2456 115.3688)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 56.1321 81.4823)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9434,
    cy: 46.5616,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 11.3818 104.505)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9441,
    cy: 12.6751,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 45.269 70.6192)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 35.1798,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -33.88643 36.47317)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.29337,
    cy: 1.2933,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 .00007 2.58667)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 35.1798,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -22.5052 47.8544)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.6746,
    cy: 1.2933,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 11.3813 13.9679)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 35.1798,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 -11.1225 59.2371)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.0573,
    cy: 1.2933,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 22.764 25.3506)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 35.1798,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 .2579 70.6175)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.4377,
    cy: 1.2933,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 34.1444 36.731)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 35.18,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 11.6397 81.9997)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.8197,
    cy: 1.29354,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 45.52616 48.11324)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 35.18,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 33.6272 103.9872)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.8072,
    cy: 1.29354,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 67.51366 70.10074)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9441,
    cy: 35.18,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 22.7641 93.1241)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.9441,
    cy: 1.29354,
    r: 1.29337,
    transform: "matrix(0 -1 1 0 56.65056 59.23764)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDottedShape);
export default __webpack_public_path__ + "static/media/dotted-shape.bbb93eb8194f92cb8d722964cfaa3bc9.svg";
export { ForwardRef as ReactComponent };